<script setup lang="ts">
import { computed } from "vue";
import { useTheme } from "@/composables/useTheme";

const props = withDefaults(defineProps<{
  compact?: boolean;
  decorative?: boolean;
  width?: number;
}>(), { compact: false, decorative: false, width: 160 });

const { isDark } = useTheme();
const source = computed(() => {
  const name = props.compact ? "yunbite-mark" : "yunbite-logo";
  const variant = isDark.value ? "-reversed" : "";
  return `${import.meta.env.BASE_URL}brand/${name}${variant}.svg`;
});
</script>

<template>
  <img
    class="brand-logo"
    :src="source"
    :alt="decorative ? '' : '云比特'"
    :aria-hidden="decorative ? true : undefined"
    :width="compact ? 32 : width"
    :height="compact ? 32 : width * 280 / 640"
    draggable="false"
  />
</template>

<style scoped>
.brand-logo {
  display: block;
  max-width: 100%;
  height: auto;
  flex: 0 0 auto;
  object-fit: contain;
}
</style>
